import { render, staticRenderFns } from "./statusUpdate.vue?vue&type=template&id=7b9cafa2&scoped=true&"
import script from "./statusUpdate.vue?vue&type=script&lang=js&"
export * from "./statusUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9cafa2",
  null
  
)

export default component.exports